import { render, staticRenderFns } from "./UserAssessmentCard.vue?vue&type=template&id=21ce7acb&"
import script from "./UserAssessmentCard.vue?vue&type=script&lang=js&"
export * from "./UserAssessmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports